import { getFeatureAvailabilityStatus } from "../../../../../app_shared_functions";
import { NO_EXTERNAL_CONNECTION_TEXT } from "../constants";
import { HostRoute } from "../hostRoutes/types";
import { AllocationPool } from "../subnet/ipv4/dhcp/types";

const splitDns = (dns: string) => {
  return dns
    .split(",")
    .map((x: string) => x.trim())
    .filter((x: string) => x);
};

export const buildBaseNetworkPayload = (
  formData: {
    [key: string]: any;
  },
  zoneId: string,
) => {
  const mtuStatus = getFeatureAvailabilityStatus({
    feature: "MTU",
    zoneId,
    component: "Create Network",
  });

  const network: any = {
    name: formData.name,
  };

  if (formData.mtu && Number(formData.mtu) && !mtuStatus) {
    network.mtu = Number(formData.mtu);
  }

  if (!formData.portSecurity) {
    network.port_security_enabled = false;
  }

  return network;
};

export const buildSubnetPayload = (
  formData: {
    [key: string]: any;
  },
  allocationPools: AllocationPool[],
  hostRoutes: HostRoute[],
  zoneId: string,
) => {
  const subnet: any = {
    ip_version: formData.ipVersion,
    dns_nameservers: splitDns(formData.dnsNameservers),
    enable_dhcp: Boolean(formData.enableDhcp),
  };

  if (formData.ipVersion === 4) {
    subnet.cidr = formData.cidr || `10.${zoneId}.0.0/24`;
  } else {
    subnet.subnetpool_id = formData.subnetPool;
    subnet.ipv6_address_mode = formData.addressingType;
  }

  if (formData.subnetName) subnet.name = formData.subnetName;
  if (formData.enableDhcp && formData.ipVersion === 4) {
    subnet.allocation_pools = allocationPools;
  }
  if (formData.ipVersion === 4 && formData.gatewayStatus) {
    subnet.gateway_ip = formData.gatewayIp || `10.${zoneId}.0.1`;
  }
  if (formData.hostRoutesStatus) {
    subnet.host_routes = hostRoutes;
  }

  return subnet;
};

export const buildRouterPayload = (formData: { [key: string]: any }) => {
  const router: any = {};
  if (formData.routerName) router.name = formData.routerName;
  if (
    formData.externalNetworkId &&
    formData.externalNetworkId !== NO_EXTERNAL_CONNECTION_TEXT
  )
    router.external_network_id = formData.externalNetworkId;
  return router;
};
